module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.merchandises), function(merchandise, index) {
    return _c('div', {
      staticClass: "product-detail"
    }, [_c('img', {
      staticClass: "product-label",
      attrs: {
        "src": _vm.getPayOrderMerchandiseLabelPath(merchandise)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "block-item",
      staticStyle: {
        "padding-top": "10px"
      }
    }, [_c('div', {
      staticClass: "block-address"
    }, [(merchandise.merchandiseDetailForClient && merchandise.merchandiseDetailForClient.merchandiseIcon) ? _c('img', {
      staticClass: "largeIcon",
      attrs: {
        "src": _vm.baseurl + merchandise.merchandiseDetailForClient.merchandiseIcon
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item-detail"
    }, [(merchandise._titleList && merchandise._titleList.length > 0) ? _c('span', {
      staticClass: "deep-text-color",
      staticStyle: {
        "font-size": "12px"
      }
    }, _vm._l((merchandise._titleList), function(title) {
      return _c('span', [(title.valueText && title.valueText !== '-1' && title.value !== '-1') ? _c('span', [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))]), _vm._v(" ")]) : _vm._e()])
    }), 0) : _vm._e(), _vm._v(" "), (merchandise._subTitleList && merchandise._subTitleList.length > 0) ? _c('span', {
      staticClass: "light-text-color tiny-font"
    }, _vm._l((merchandise._subTitleList), function(subTitle, index) {
      return _c('span', [(index !== 0) ? _c('span', [_vm._v("/")]) : _vm._e(), _vm._v(" "), (subTitle.valueText && subTitle.valueText !== '-1' && subTitle.value !== '-1') ? _c('span', [_vm._v(_vm._s(subTitle.valueText))]) : _vm._e()])
    }), 0) : _vm._e(), _vm._v(" "), (merchandise._abstractList && merchandise._abstractList.length > 0) ? _c('span', {
      staticClass: "light-text-color tiny-font"
    }, _vm._l((merchandise._abstractList), function(abstractTitle, index) {
      return _c('span', [(abstractTitle.valueText && abstractTitle.valueText !== '-1' && abstractTitle.value !== '-1') ? _c('span', [(abstractTitle.columnName === 'TVInfo' && abstractTitle.valueText.TLNo !== undefined) ? _c('span', [_vm._v(_vm._s(abstractTitle.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstractTitle.valueText))]), _vm._v(" ")]) : _vm._e()])
    }), 0) : _vm._e()])]), _vm._v(" "), _c('span', {
      staticClass: "light-text-color"
    }, [_vm._v("X " + _vm._s(merchandise.quantity))])]), _vm._v(" "), _c('div', {
      staticClass: "price-info"
    }, [(_vm.getMerchandiseDiscount(merchandise) < 1) ? _c('span', {
      staticClass: "alert-text tiny-font bold-text"
    }, [_vm._v(_vm._s(_vm.getMerchandiseCategory(merchandise)) + _vm._s(_vm.getMerchandiseDiscount(merchandise)) + "折")]) : _vm._e(), _vm._v(" "), (_vm.getMerchandiseInitPrice(merchandise) > merchandise.price) ? _c('span', {
      staticClass: "light-text-color tiny-font",
      staticStyle: {
        "text-decoration": "line-through"
      }
    }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.getMerchandiseInitPrice(merchandise))))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "research-font-color bold-text"
    }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(merchandise.price)))])]), _vm._v(" "), _c('div', {
      staticClass: "split-line"
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("折后价小记")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end"
    }
  }, [(_vm.catalogueTotalPrice > _vm.goodsPrice) ? _c('span', {
    staticClass: "light-text-color tiny-font",
    staticStyle: {
      "text-decoration": "line-through"
    }
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.catalogueTotalPrice)))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "research-font-color bold-text"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.goodsPrice)))])])]), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "30px"
    }
  }, [_c('div', [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("运费")]), _vm._v(" "), _c('i', {
    staticClass: "icon-font emkt-icon-gantanhao light-text-color",
    staticStyle: {
      "font-size": "13px"
    },
    on: {
      "click": _vm.showExpressMessage
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "research-font-color bold-text"
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.expressFee)))])]), _vm._v(" "), (_vm.showCashCoupon) ? _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("现金券")]), _vm._v(" "), _c('span', {
    staticClass: "bold-text alert-text"
  }, [_vm._v("- ¥" + _vm._s(_vm.emkt.formatPrice(_vm.cashCoupon.value)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "full-split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("共" + _vm._s(_vm.totalCount) + "件商品")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("总计")]), _vm._v(" "), _c('span', {
    staticClass: "research-font-color bold-text",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("¥" + _vm._s(_vm.emkt.formatPrice(_vm.totalPrice)))])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-507fdc48","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_v_2.6/Order/OrderMerchandises.vue
// module id = 1633
// module chunks = 8